// src/components/Header.js

import React from "react";
import { Link } from "react-router-dom"; // Import Link component for navigation

const Header = () => {
  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    alert("Logged out successfully!");
    window.location.href = "/login"; // Using window.location.href for a full page reload after logout
  };

  return (
    <nav className="navbar navbar-light bg-light bg-gradient px-3 h-25">
      <div className="container-fluid">
        <a className="navbar-brand d-flex align-items-center" >
          <img src="https://timehouse.store/logo-red.svg" alt="Logo" className="me-2" />
        </a>
        <div className="d-flex">
          {/* Using Link instead of button */}
          <Link className="btn  me-2 text-decoration-none" to="/user/home">
            Accounts
          </Link>
          <Link className="btn  me-2 text-decoration-none" to="/user/dailyTasks">
            Operations
          </Link>
          <button className="btn btn-danger ml-5" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Header;
